export default {"grid":"GiCIva_grid","backdrop":"GiCIva_backdrop","ripple":"GiCIva_ripple","wave":"GiCIva_wave","wash":"GiCIva_wash",}